import React from "react";
import {Button, Card, Form, Image, Input, message, Row, Space} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import logo from '../assets/img/logo192.png'
import {ApiService} from "../services/ApiService";
import {useNavigate} from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate()

    let formData = {}

    const handleValueChange = (changed, all) => {
        formData = {...all}
    }

    const handleLoginClick = (event) => {
        if (!formData.password || formData.password.length === 0){
            message.error("请输入密码")
            return false
        }
        if (!formData.username || formData.username.length === 0) {
            message.error("请输入用户名")
            return false
        }
        ApiService.user.login(formData.username, formData.password)
            .onSuccess(user => {
                message.success(user.username + " 欢迎回来。")
                navigate(-1, {replace: true})
            })
    }

    return (
        <>
            <Row align={'center'} style={{paddingTop: 120, marginBottom: 64}}>
                <Space align={'center'}>
                    <Image width={30} height={30} src={logo} preview={false}/>
                    <span style={{fontSize: 25, fontWeight: 'bold'}}>智慧统战政务联动系统</span>
                </Space>
            </Row>

            <div style={{textAlign: 'center', display: 'flex', justifyContent: 'center'}}>
                <Card className="shadow" style={{width: 300}}>
                    <Form name="login" autoComplete="off" onValuesChange={handleValueChange}>
                        <Form.Item name="username">
                            <Input prefix={<UserOutlined className="site-form-item-icon"/>}/>
                        </Form.Item>

                        <Form.Item name="password">
                            <Input.Password prefix={<LockOutlined className="site-form-item-icon"/>}/>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" onClick={handleLoginClick}>登录</Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </>
    )
}

export default LoginPage